import { PaymentDirections } from './payment-directions';
import { PaymentRequisite } from './payment-requisites';
import { PaymentProfileRestrictionSetting } from './payment-restrictions';

export enum PaymentProfileStatus {
    Active = 'ACTIVE',
    Inactive = 'INACTIVE',
    Deleted = 'DELETED'
}

export interface PaymentProfileListItem {
    id: number;
    title: string;
    dailyLimit: string;
    totalOrderAmountForToday: string;
    status: PaymentProfileStatus;
    address: string;
    direction: PaymentDirections;
}

export interface PaymentProfile {
    id: number;
    title: string;
    paymentMethodId: number;
    direction: PaymentDirections;
    status: PaymentProfileStatus;
    requisites: PaymentRequisite;
    restrictionSettings: PaymentProfileRestrictionSetting[];
    createdAt?: string;
}
